export default __webpack_public_path__ + "static/media/sf_logo.8b22b9d7.svg";